import { UserRolePage } from "./user-role-page";
// Removed patient dashboard filter types for reports-only app

export class UserRole {
  userRoleId?: number;
  roleName!: string;
  roleDesc!: string;
  roleType!: string;
  isActive!: boolean;
  userRolePages!: UserRolePage[];
  patientDashboardFilters!: null;
}

export const emptyUserRole: UserRole  = {
  roleName: "",
  roleDesc: "",
  roleType: "",
  isActive: true,
  userRolePages: [],
  patientDashboardFilters: null,
}



